export const routesTanitimDofKaynak = [
  {
    path: "/kys-dof-kaynak",
    name: "kys-dof-kaynak",
    component: () => import("@/views/kystanitim/dof-kaynak/index.vue"),
    meta: {
      public: false,
      title: "kystanitim.Döf Kaynak Tanıtım",
      yetki: { k: [1190202] },
    },
  },
]
